import React from 'react';
import { Button, Dropdown, Tabs, Input, Popover } from 'freemium-ui';
import { useController, useFormContext } from 'react-hook-form';

export type HFDropdownProps = {
  name: string;
  defaultValue: any;
  items: any;
  itemToString?: any;
  placeholder?: any;
  disabled?: any;
  itemComponent?: any;
  itemKeyId?: any;
};

export const HFDropdown = ({
  name,
  items,
  defaultValue,
  itemComponent,
  placeholder = '-- --- --',
  disabled = false,
  itemKeyId = 'id',
  itemToString = (item: any) => item.label,
}: HFDropdownProps) => {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
    defaultValue,
  });
  const props = {
    ...(itemComponent && { itemComponent }),
  };
  // console.log('propsprops', props);
  return (
    <Dropdown
      defaultSelectedItem={
        items.find((opt: any) => opt[itemKeyId] === field.value) || items[0]
      }
      {...props}
      items={items}
      itemToString={itemToString}
      onChange={(item: any) => {
        field.onChange(item[itemKeyId]);
      }}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
};

export default HFDropdown;
